import { Route, Routes } from "react-router-dom";

import { SystemBreadcrumbs } from "../../breadcrumbs/SystemBreadcrumbs";
import { PoisonMessages } from "./Events";
import { OpsReport } from "./OpsReport";
import { Roles } from "./Roles";
import { SystemEnvTabs } from "./system-env-tabs.constants";
import { Users } from "./Users";

export const SystemEnvRoutes = () => {
  return (
    <Routes>
      <Route element={<SystemBreadcrumbs tabs={SystemEnvTabs} />}>
        <Route path={SystemEnvTabs.User.Manage.id} element={<Users />} />
        <Route path={SystemEnvTabs.Roles.View.id} element={<Roles />} />
        <Route
          path={SystemEnvTabs.Events.PoisonMessages.id}
          element={<PoisonMessages />}
        />
        <Route
          path={`${SystemEnvTabs.OpsReports.Report.id}/:name`}
          element={<OpsReport />}
        />
      </Route>
    </Routes>
  );
};
